export enum Commodity {
  'gas' = 'gas',
  'power' = 'power',
}
